export default __webpack_public_path__ + "locales/ru/DataReassignmentDialog.json?hash=f199625f623bbf7ae035be9923521478";